import { render, staticRenderFns } from "./mealComponent.vue?vue&type=template&id=27fcd651&scoped=true&"
import script from "./mealComponent.vue?vue&type=script&lang=js&"
export * from "./mealComponent.vue?vue&type=script&lang=js&"
import style0 from "./mealComponent.vue?vue&type=style&index=0&id=27fcd651&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fcd651",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/builder/shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27fcd651')) {
      api.createRecord('27fcd651', component.options)
    } else {
      api.reload('27fcd651', component.options)
    }
    module.hot.accept("./mealComponent.vue?vue&type=template&id=27fcd651&scoped=true&", function () {
      api.rerender('27fcd651', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mealComponent/mealComponent.vue"
export default component.exports